import Vue from 'vue';
import { tuncateText, formatSaudiPhoneNumber, uppercase, getSecondaryLanguageText, translateToSecondaryLanguage } from '@/utils/text';
import { formatDate, formatDateWith, formatDateTime, monthYear, year, getDateFromServerTimeStampOrNow } from '@/utils/date';
import { currency, creditCardExpiryDate, priceByFrequency, formatCurrency } from '@/utils/numbers';

Vue.filter('formatDate', formatDate);
Vue.filter('formatDateWith', formatDateWith);
Vue.filter('getDateFromServerTimeStampOrNow', getDateFromServerTimeStampOrNow);
Vue.filter('formatDateTime', formatDateTime);
Vue.filter('uppercase', uppercase);
Vue.filter('formatSaudiPhoneNumber', formatSaudiPhoneNumber);
Vue.filter('truncate', tuncateText);
Vue.filter('getSecondaryLanguageText', getSecondaryLanguageText);
Vue.filter('translateToSecondaryLanguage', translateToSecondaryLanguage);
Vue.filter('currency', currency);
Vue.filter('creditCardExpiryDate', creditCardExpiryDate);
Vue.filter('monthYear', monthYear);
Vue.filter('year', year);
Vue.filter('priceByFrequency', priceByFrequency)
Vue.filter('formatCurrency', formatCurrency)